import bodegaService from '@/services/bodega.service.js'
import usuarioService from '@/services/usuario.service.js'

export default {
  namespaced: true,
  state: {
    usuarios: []
  },
  mutations: {
    UPDATE_USUARIOS(state, payload) {
      state.usuarios = payload
    },
    CAMBIAR_ESTADO(state, payload) {
      state.usuarios = state.usuarios.map((item) => {
        if (item.id === payload) {
          item.estaDisponible = !item.estaDisponible
        }
        return item
      })
    }
  },
  actions: {
    updateUsuarios({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        bodegaService
          .getUsuariosByBodega(rootState.sesion.bodega.id)
          .then((response) => {
            commit('UPDATE_USUARIOS', response.data)
            resolve()
          })
          .catch((error) => reject(error))
      })
    },
    updateUsuario({ commit }, payload) {
      return new Promise((resolve, reject) => {
        usuarioService
          .addDisponibilidadByUsuario(payload.usuarioId, payload.objeto)
          .then(() => {
            commit('CAMBIAR_ESTADO', payload.usuarioId)
            resolve()
          })
          .catch((error) => reject(error))
          .then(() => (this.isLoading = false))
      })
    }
  },
  modules: {}
}
